// Lib
import React from 'react';
import { IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const ContentOnlyHeader = ({
  isDesktopMode,
  isMobileMode,
  classes,
  title,
  onToggleSearchInput,
}) => (
  <>
    {isDesktopMode && <div className={classes.additionalTitle}>{title}</div>}
    {isMobileMode && (
      <IconButton
        className={classes.searchIcon}
        id="search-button"
        edge="start"
        aria-label="search"
        onClick={onToggleSearchInput}>
        <SearchIcon />
      </IconButton>
    )}
  </>
);

export default ContentOnlyHeader;
